<script>
import { settingsService } from "@/libs/ws/settingsService";
export default {
  data() {
    return {
      settings: null,
    };
  },
  mounted() {
  },
  methods: {

    updateSettings(reload = false) {
      settingsService
        .filter({})
        .then((response) => {
          this.settings = response.result;
          localStorage.setItem("settings", JSON.stringify(response.result));
          if (reload) {
            location.reload();
          }
        })
        .catch((e) => {});
    },

  },
};
</script>
